import React, { useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import MyToastify from 'src/components/myComponents/MyToactify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import CustomPagination from 'src/components/pagination/CustomPaginatiion';

const page = 1;
const pageSize = 20;
const urlApi = '/locations';
const urlRouter = '/locations';

export async function LoaderLocations({ params }) {
  let res = await AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => {
    return response;
  });
  return res;
};

const Locations = () => {
  const { data } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = React.useState(0);

  // Викликає popup з власного компонента
  const popup = MyToastify();
  // Текст для popup
  const popupTextDeleteSuccess = "Підрозділ видалено";

  if (!rows) {
    setRowCountState(data['hydra:totalItems'])
    setRows(data['hydra:member']);
  };

  const getRowsTable = (p = 1) => {
    AxiosInstance.get(`${urlApi}?page=${p}`).then((response) => {
      setRows(response.data['hydra:member']);
    });
  };

  const handlePageChange = (page) => {
    getRowsTable(page + 1);
  };

  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            const response = AxiosInstance.delete(`${urlApi}/${row.id}`).then((response) => {
              getRowsTable();
              // Вивести popup про успішне видалення замовлення
              popup.toastifySuccess(popupTextDeleteSuccess);
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 30 },
    {
      field: 'name', headerName: 'Назва', width: 200,
      renderCell: (params) => {
        return <Link to={`${urlRouter}/update/${params.row.id}`} style={{ textDecoration: "none", color: "rgba(0, 0, 0, 0.87)" }}>{params.row.name}</Link>;
      }
    },

    { field: 'description', headerName: 'Опис', width: 400 },
    // { field: 'parent', headerName: 'parent', width: 200 },

    // {
    //   field: 'created_at',
    //   headerName: 'Дата',
    //   type: 'date',
    //   width: 160,
    // },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      width: 65,
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,

      // renderCell: (params) => {
      //   return <Link to={`${urlRouter}/update/${params.row.id}`}><CButton color="dark" variant="outline" title="Редагувати підрозділ"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }
      renderCell: (params) => {
        return <Link to={`${urlRouter}/update/${params.row.id}`}><img src="/edit.svg" alt="edit" /></Link>;
      }
    },
    {
      field: "delete",
      headerName: "Видалити",
      sortable: false,
      width: 85,
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      // renderCell: (params) => {
      //   return <CButton color="danger" variant="outline" onClick={() => { Deleted(params.row) }} title="Видалити підрозділ"
      //   > <CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton >;
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }

    },
  ];

  return (
    <>
      {/* Popup про успішні зміни (справа зверху) */}
      <ToastContainer />

      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4 mt-4">
            <CCardHeader className='items_card_header'>
              {/* <strong> */}
              Підрозділи
              {/* </strong>  */}
              <small></small>
            </CCardHeader>
            <CCardBody>
              <div className='head_items_wrapper_solo'>
                <p className="text-medium-emphasis small">
                  <Link to={`${urlRouter}/create`} className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />Add</CButton></Link>
                </p>
              </div>
              <div style={{ height: 600, width: '100%' }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={30}
                  rowsPerPageOptions={[30]}
                  pagination
                  rowCount={rowCountState}
                  paginationMode="server"
                  onPageChange={handlePageChange}

                  components={{ Pagination: CustomPagination }}
                  headerHeight={44}

                  sx={{
                    borderRadius: '12px',
                    border: '1px solid #ccc',

                    '& .MuiDataGrid-main': {
                      // borderRadius: '12px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      borderTopLeftRadius: '12px',
                      borderTopRightRadius: '12px',
                      fontFamily: 'Inter',
                      fontWeight: '600',
                      fontSize: '12px',
                      lineheight: '150%',
                      color: '#717680',
                      //   borderBottom: '2px solid #4e73df',

                    },
                    '& .MuiDataGrid-cell': {
                      fontFamily: 'Inter',
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#434349',
                    },
                    '& .MuiDataGrid-footerContainer': {
                      // borderBottomLeftRadius: '12px',
                      // borderBottomRightRadius: '12px',
                    },
                  }}
                />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default Locations;